
<header *ngIf="showHeader" class="sx-login-header">
    <div class="body">
        <div class="sx-navbar fixed-top--onboarding navbar-light" >
            <div class="sx-navbar__header-wrapper">
                <div class="sx-topheader__logo sxl-full-height sxl-flex-1" [routerLink]="['/secure/dashboard']" routerLinkActive="router-link-active" >
                    <svg>
                        <use xlink:href="#stockholm-exergi-flat" href="#stockholm-exergi-flat"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <div class="sx-login-header__progress-container">
        <div class="sx-login-header__progress" [class.sx-login-header__progress-90]="addCustomerViewActive"></div>
    </div>
</header>